import React from "react";
import CashierShiftGenericSkeleton from "./CashierShiftGenericSkeleton";

function CashierShiftDetailSkeleton() {
  return (
    <>
      <CashierShiftGenericSkeleton />
    </>
  );
}

export default CashierShiftDetailSkeleton;
